import { NavLink } from 'react-router-dom';
import { useMenuContext } from "../../store/MenuContext";

const Sidebar = () => {
    const menuCtx = useMenuContext()
    return (
        <div className="navbar w-100 align-items-start px-4">
            <ul className="navbar-nav flex-column w-100">
                {menuCtx.items.map((item, index) => {
                    return (
                        <li className="nav-item" key={index}>
                            <NavLink to={item.url}
                                className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
                                end={index === 0}>
                                <div className="d-flex justify-content-between">
                                    {item.name}
                                </div>
                            </NavLink>
                            {item.children && item.children.length > 0 &&
                                <ul className="nav flex-column ms-2">
                                    {item.children.map((child, childIndex) => (
                                        <li className="nav-item" key={childIndex}>
                                            <NavLink
                                                to={child.url}
                                                end
                                                className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
                                            >
                                                {child.name}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            }
                        </li>
                    )
                }
                )}
            </ul>
        </div>

    )
};


export default Sidebar;
